export default "__VITE_ASSET__CkgoFjqt__"